import { palette, rgba } from '@aegislab/design-tokens';

export const statusBgTokens = {
  pending: rgba(palette.violet, 0.2),
  inProgress: rgba(palette.blue, 0.1),
  completed: rgba(palette.green, 0.2),
  failed: rgba(palette.red, 0.2),
  archived: rgba(palette.slate, 0.2),
} as const;

export type StatusBgTokens = typeof statusBgTokens;
